import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AssociacoesService {

  constructor(
    private httpService: HttpService
  ) { }

  partnerSearch(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/partnerSearch', data, successHandle, errorHandle);

  }

  inactivatePartner(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doPost('/inactivatePartner', data, successHandle, errorHandle);

  }
 
 
}
